import types from '../constants/OnlineCoursePollActionTypes';
import {
  createItemFail,
  createItemSuccess,
  fetchItemFail,
  fetchItemsFail,
  fetchItemsSuccess,
  fetchItemSuccess,
  removeItemFail,
  removeItemSuccess,
  updateItemFail,
  updateItemSuccess,
} from './utils';

const initialState = {
  status: { fetch: {} },
  items: {},
};

export default function onlineCoursePolls(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ONLINE_COURSE_POLL_SUCCESS:
      return fetchItemSuccess(state, action);
    case types.FETCH_ONLINE_COURSE_POLL_FAIL:
      return fetchItemFail(state, action);

    case types.FETCH_ONLINE_COURSE_POLLS_SUCCESS:
      return fetchItemsSuccess(state, action);
    case types.FETCH_ONLINE_COURSE_POLLS_FAIL:
      return fetchItemsFail(state, action);

    case types.CREATE_ONLINE_COURSE_POLL_SUCCESS:
      return createItemSuccess(state, action);
    case types.CREATE_ONLINE_COURSE_POLL_FAIL:
      return createItemFail(state, action);

    case types.UPDATE_ONLINE_COURSE_POLL_SUCCESS:
      return updateItemSuccess(state, action);
    case types.UPDATE_ONLINE_COURSE_POLL_FAIL:
      return updateItemFail(state, action);

    case types.DELETE_ONLINE_COURSE_POLL_SUCCESS:
      return removeItemSuccess(state, action);
    case types.DELETE_ONLINE_COURSE_POLL_FAIL:
      return removeItemFail(state, action);

    default:
      return state;
  }
}
